module.exports = __webpack_public_path__ + "img/curv_21_a.fa662dd2.jpg";